import React, { useEffect, useState } from 'react';
import { getCertificateUrl, loadCertificates } from '../../data/getCertificateUrl';

export function CertificateLink({ item }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let cancelled = false;

    loadCertificates().then((certificates) => {
      if (cancelled) return;
      setUrl(getCertificateUrl(item, certificates));
    });

    return () => {
      cancelled = true;
    };
  }, [item]);

  if (!url) return null;

  const isLink = /^https?:\/\//i.test(url);

  return (
    <div className='attrRow certificateRow'>
      <span>Сертификат соответствия:</span>
      {isLink ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          Открыть
        </a>
      ) : (
        'обязательное подтверждение соответствия не требуется'
      )}
    </div>
  );
}
